import React, { useState } from 'react';
import logo from '../../logo.png';
import { Typography, TextField, Button, CircularProgress, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { login } from '../../actions/auth';
import * as api from '../../api';


const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 150,
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    textAlign: 'center'
  },
  logo: {
    width: 500,
    maxWidth: '100%',
    marginBottom: 40,
  },
  form: {
    maxWidth: 300,
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
  }
}));


function Login(props) {
  const [user, setUser] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  
  const dispatch = useDispatch();
  const classes = useStyles();


  const handleChange = (evt) => {
    setUser({
      ...user,
      [evt.target.name]: evt.target.value
    });
  }

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setLoading(true);

    api.login(user)
      .then(res => {
        let { token, user } = res;
        dispatch(login(token, user));
      })
      .catch(err => {
        let { response } = err;
        if (response.status === 401) alert(response.data.message);
        else console.log(err.response);
        setLoading(false);
      });
  }


  return (
    <div className={classes.root}>
      <img className={classes.logo} src={logo} alt="Logo" />
      <Typography variant="h4">Login</Typography>

      <form
        className={classes.form}
        onChange={handleChange}
        onSubmit={handleSubmit}
      >

        <TextField
          id="login-email"
          name="email"
          label="Email/User"
          value={user.email}
          variant="outlined"
          margin="normal"
          fullWidth
        />

        <TextField
          id="login-password"
          name="password"
          label="Password"
          value={user.password}
          type="password"
          variant="outlined"
          margin="normal"
          fullWidth
        />

        {loading
          ? <CircularProgress />
          : <Button
              className={classes.submit}
              variant="outlined"
              type="submit">
                Submit
            </Button>}

      </form>
    </div>
  );
}


export default Login;